/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BaseResponse } from '../models/base-response';
import { notificationControllerCountMyNotifications } from '../fn/notification/notification-controller-count-my-notifications';
import { NotificationControllerCountMyNotifications$Params } from '../fn/notification/notification-controller-count-my-notifications';
import { notificationControllerGetMyNotifications } from '../fn/notification/notification-controller-get-my-notifications';
import { NotificationControllerGetMyNotifications$Params } from '../fn/notification/notification-controller-get-my-notifications';
import { notificationControllerMarkMyNotificationsAsRead } from '../fn/notification/notification-controller-mark-my-notifications-as-read';
import { NotificationControllerMarkMyNotificationsAsRead$Params } from '../fn/notification/notification-controller-mark-my-notifications-as-read';
import { notificationControllerMarkNotificationAsRead } from '../fn/notification/notification-controller-mark-notification-as-read';
import { NotificationControllerMarkNotificationAsRead$Params } from '../fn/notification/notification-controller-mark-notification-as-read';
import { NotificationCount } from '../models/notification-count';
import { NotificationList } from '../models/notification-list';

@Injectable({ providedIn: 'root' })
export class NotificationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `notificationControllerGetMyNotifications()` */
  static readonly NotificationControllerGetMyNotificationsPath = '/notification';

  /**
   * Restituisce l'elenco delle notifiche.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `notificationControllerGetMyNotifications()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationControllerGetMyNotifications$Response(params: NotificationControllerGetMyNotifications$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: NotificationList;
}>> {
    return notificationControllerGetMyNotifications(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco delle notifiche.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `notificationControllerGetMyNotifications$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationControllerGetMyNotifications(params: NotificationControllerGetMyNotifications$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: NotificationList;
}> {
    return this.notificationControllerGetMyNotifications$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: NotificationList;
}>): BaseResponse & {
'data'?: NotificationList;
} => r.body)
    );
  }

  /** Path part for operation `notificationControllerCountMyNotifications()` */
  static readonly NotificationControllerCountMyNotificationsPath = '/notification/count';

  /**
   * Restituisce il conteggio delle notifiche da leggere.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `notificationControllerCountMyNotifications()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationControllerCountMyNotifications$Response(params?: NotificationControllerCountMyNotifications$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: NotificationCount;
}>> {
    return notificationControllerCountMyNotifications(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce il conteggio delle notifiche da leggere.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `notificationControllerCountMyNotifications$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationControllerCountMyNotifications(params?: NotificationControllerCountMyNotifications$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: NotificationCount;
}> {
    return this.notificationControllerCountMyNotifications$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: NotificationCount;
}>): BaseResponse & {
'data'?: NotificationCount;
} => r.body)
    );
  }

  /** Path part for operation `notificationControllerMarkMyNotificationsAsRead()` */
  static readonly NotificationControllerMarkMyNotificationsAsReadPath = '/notification/mark-as-read';

  /**
   * Imposta tutte le proprie notifiche come lette.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `notificationControllerMarkMyNotificationsAsRead()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationControllerMarkMyNotificationsAsRead$Response(params?: NotificationControllerMarkMyNotificationsAsRead$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return notificationControllerMarkMyNotificationsAsRead(this.http, this.rootUrl, params, context);
  }

  /**
   * Imposta tutte le proprie notifiche come lette.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `notificationControllerMarkMyNotificationsAsRead$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationControllerMarkMyNotificationsAsRead(params?: NotificationControllerMarkMyNotificationsAsRead$Params, context?: HttpContext): Observable<void> {
    return this.notificationControllerMarkMyNotificationsAsRead$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `notificationControllerMarkNotificationAsRead()` */
  static readonly NotificationControllerMarkNotificationAsReadPath = '/notification/mark-as-read/{id}';

  /**
   * Imposta una notifica come letta.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `notificationControllerMarkNotificationAsRead()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationControllerMarkNotificationAsRead$Response(params: NotificationControllerMarkNotificationAsRead$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return notificationControllerMarkNotificationAsRead(this.http, this.rootUrl, params, context);
  }

  /**
   * Imposta una notifica come letta.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `notificationControllerMarkNotificationAsRead$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationControllerMarkNotificationAsRead(params: NotificationControllerMarkNotificationAsRead$Params, context?: HttpContext): Observable<void> {
    return this.notificationControllerMarkNotificationAsRead$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
